import Vue from "vue";
import pt from "vuetify/es5/locale/pt";
import Vuetify from "vuetify/lib";

import main from "./themes/mainTheme";

import "@fortawesome/fontawesome-free/css/all.css";
import "font-awesome/css/font-awesome.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
  icons: {
    iconfont: "md",
  },
  theme: {
    themes: {
      light: main,
    },
    // dark: true,
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
};

export default new Vuetify(opts);
